module.exports = __webpack_public_path__ + "img/32.16788da3.png";